import React from 'react';

import { styled } from '@mui/material/styles';
const PREFIX = 'HeaderDemo';

const classes = {
    demo: `${PREFIX}-demo`,
    demoIcon: `${PREFIX}-demoIcon`,
    demoName: `${PREFIX}-demoName`,
    button: `${PREFIX}-button`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`&.${classes.demo}`]: {
		flex: 1,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},

    [`& .${classes.demoIcon}`]: {},

    [`& .${classes.demoName}`]: {
		marginLeft: theme.spacing(1),
		[theme.breakpoints.down('lg')]: {
			display: 'none',
		},
	},

    [`& .${classes.button}`]: {
		margin: theme.spacing(1),
		[theme.breakpoints.down('lg')]: {
			margin: 3,
		},
	}
}));

// const SupportLink = React.forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => (
//   <Link innerRef={ref as any} {...props} />
// ))

const HeaderDemo: React.FC<any> = (props) => {


	return <Root className={classes.demo}></Root>;
};

export default HeaderDemo;
